/**
 * The function for frontend widget elementor
 *
 * Author: Made Indonesia Developer
 *
 * @package HelloElementor
 */

/*
 * Layout Component
 */

// Top Header
import "./layouts/topHeader/frontend"

// Navigation
import "./layouts/navigation/frontend"

/*
 * Base Component
 */

// Language Switcher
import "./components/languangeSwitcher"

/*
 * Custom Widget Elementor
 */

// Brand Tabs Widget
import "./widgets/brandTab/frontend"

// Blog Tabs Widget
import "./widgets/blogTab/frontend"

// Crebos Values Widget
import "./widgets/crebosValues/frontend"

// Crebos Culture Widget
import "./widgets/crebosCulture/frontend"

// Career Filter Widget
import "./widgets/careerFilter/frontend"

// Career Filter Widget by Ajax
import "./widgets/careerFilter/ajax-career-filter"

// Share Links Widget
// import "./widgets/shareButton/frontend";

// Share Links Contact
import "./widgets/customInput/frontend"

// Story Widget
import "./widgets/story/frontend"
